// Generated from source/ by scripts/generate.ts. Do not edit by hand.
import type { IconData } from "../types.js";

const m0 =
  '<path d="M12 18.1L14.33 15.77Q14.63 15.47 15.05 15.47T15.77 15.77 16.07 16.49 15.77 17.21L12.7 20.3Q12.55 20.45 12.37 20.51T11.99 20.57 11.61 20.51 11.28 20.3L8.2 17.22Q7.9 16.92 7.9 16.5T8.2 15.78 8.92 15.48 9.64 15.78ZM12 6L9.68 8.32Q9.38 8.62 8.96 8.62T8.24 8.32 7.94 7.6 8.24 6.88L11.3 3.8Q11.45 3.65 11.63 3.59T12 3.53 12.38 3.59 12.71 3.8L15.79 6.88Q16.09 7.18 16.09 7.6T15.79 8.32 15.07 8.62 14.35 8.32Z"/>';

/** Expand (navigation). */
const icon: IconData = {
  id: "expand",
  name: "Expand",
  category: "navigation",
  styles: {
    rounded: { svg: m0 },
    sharp: {
      svg: '<path d="M12 21L7.5 16.5 8.95 15.05 12 18.1 15.05 15.05 16.5 16.5ZM8.95 9.05L7.5 7.6 12 3.1 16.5 7.6 15.05 9.05 12 6Z"/>',
    },
    outline: { svg: m0 },
    duotone: {
      svg: '<g opacity=".32"><path d="M12 18.1L14.33 15.77Q14.63 15.47 15.05 15.47T15.77 15.77 16.07 16.49 15.77 17.21L12.7 20.3Q12.55 20.45 12.37 20.51T11.99 20.57 11.61 20.51 11.28 20.3L8.2 17.22Q7.9 16.92 7.9 16.5T8.2 15.78 8.92 15.48 9.64 15.78ZM12 6L9.68 8.32Q9.38 8.62 8.96 8.62T8.24 8.32 7.94 7.6 8.24 6.88L11.3 3.8Q11.45 3.65 11.63 3.59T12 3.53 12.38 3.59 12.71 3.8L15.79 6.88Q16.09 7.18 16.09 7.6T15.79 8.32 15.07 8.62 14.35 8.32Z"/></g><path d="M12 18.1L14.33 15.77Q14.63 15.47 15.05 15.47T15.77 15.77 16.07 16.49 15.77 17.21L12.7 20.3Q12.55 20.45 12.37 20.51T11.99 20.57 11.61 20.51 11.28 20.3L8.2 17.22Q7.9 16.92 7.9 16.5T8.2 15.78 8.92 15.48 9.64 15.78ZM12 6L9.68 8.32Q9.38 8.62 8.96 8.62T8.24 8.32 7.94 7.6 8.24 6.88L11.3 3.8Q11.45 3.65 11.63 3.59T12 3.53 12.38 3.59 12.71 3.8L15.79 6.88Q16.09 7.18 16.09 7.6T15.79 8.32 15.07 8.62 14.35 8.32Z"/>',
    },
  },
  animation: () => import("../animations/expand.js"),
};

export default icon;
